module.exports = __webpack_public_path__ + "static/img/_body-bg.51a60be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/authorization/_body-bg.png
// module id = 9mnx
// module chunks = 31